import script from "./AddMandatoryBoothRefinementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMandatoryBoothRefinementModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMandatoryBoothRefinementModal.vue?vue&type=style&index=0&id=111090a2&lang=scss"

const __exports__ = script;

export default __exports__